import React, { memo } from "react";
import { IconButton, useTheme } from "@mui/material";
import { CheckBox, Delete } from "@mui/icons-material";
import editVacancySliderController from "./editVacancySlider.Controller";
import { EditVacancySliderProps } from "./editVacancySlider.interface";
import { MultipleSelectionDropDown, Slider, SnackBar } from "@component";
import { vacancyCategoryData } from "./editVacancySlider.const";
import {
  StyledButton,
  StyledButtonContainer,
  StyledChooseButton,
  StyledChooseFileContainer,
  StyledChooseText,
  StyledContainer,
  StyledErrorText,
  StyledFileInput,
  StyledFileText,
  StyledInput,
  StyledLabel,
  StyledSelectionButton,
  StyledText,
} from "./editVacancySlider.style";

const EditVacancySlider: React.FC<EditVacancySliderProps> = ({
  openDrawer,
  handleCloseIcon,
  vacancyId,
  userId,
}) => {
  const theme = useTheme();
  const {
    description,
    expectedSalary,
    experience,
    noOfPosition,
    qualification,
    removeFile,
    selectedVacancy,
    selectedFile,
    setDescription,
    setExpectedSalary,
    setExperience,
    setNoOfPosition,
    setQualification,
    setRemoveFile,
    setSelectedFile,
    setWorkAs,
    workAs,
    error,
    selectedFileError,
    handleCloseSnackBar,
    openSnackBar,
    snackBarMessage,
    loading,
    handleSelectFile,
    validation,
    onDeleteIcon,
    selectedCategory,
    setSelectMainCategory,
    setSelectSubMainCategory,
    setSelectedCategory,
  } = editVacancySliderController({
    handleCloseIcon,
    openDrawer,
    userId,
    vacancyId,
  });
  return (
    <Slider
      openDrawer={openDrawer}
      handleCloseIcon={() => {
        handleCloseIcon();
      }}
      title={vacancyId ? "Edit Vacancy" : "Add Vacancy"}
    >
      <StyledContainer>
        <MultipleSelectionDropDown
          data={vacancyCategoryData}
          placeholder={selectedVacancy}
          onSelectValue={(
            details: any,
            mainCategory: any,
            subMainCategory: any
          ) => {
            setSelectMainCategory(mainCategory);
            setSelectSubMainCategory(subMainCategory);
            setSelectedCategory(details);
          }}
          values={selectedCategory}
        />
        <StyledText>Qualification</StyledText>
        <StyledInput
          variant="outlined"
          placeholder="Qualification"
          InputLabelProps={{ style: { color: theme.palette.common.black } }}
          value={qualification}
          onChange={(val) => setQualification(val?.target?.value)}
          helperText={error.qualificationError}
        />
        <StyledText>Experience</StyledText>
        <StyledInput
          variant="outlined"
          placeholder="Experience"
          InputLabelProps={{ style: { color: theme.palette.common.black } }}
          value={experience}
          onChange={(val) => setExperience(val?.target?.value)}
          helperText={error.experienceError}
        />
        <StyledText>Description</StyledText>
        <StyledInput
          variant="outlined"
          placeholder="Description"
          InputLabelProps={{ style: { color: theme.palette.common.black } }}
          value={description}
          multiline
          rows={5}
          onChange={(val) => setDescription(val?.target?.value)}
          helperText={error.descriptionError}
        />
        <StyledText>No. of Position</StyledText>
        <StyledInput
          variant="outlined"
          placeholder="No. of Position"
          InputLabelProps={{ style: { color: theme.palette.common.black } }}
          value={noOfPosition}
          onChange={(val) => setNoOfPosition(val?.target?.value)}
          helperText={error.noOfPositionError}
        />
        <StyledText>Expected Salary</StyledText>
        <StyledInput
          variant="outlined"
          placeholder="Expected Salary"
          InputLabelProps={{ style: { color: theme.palette.common.black } }}
          value={expectedSalary}
          onChange={(val) => setExpectedSalary(val?.target?.value)}
          helperText={error.expectedSalaryError}
        />
        <StyledText>Add Attachment</StyledText>
        <StyledFileInput
          id="selectPortfolio"
          type="file"
          onChange={handleSelectFile}
        />
        <StyledChooseFileContainer>
          <StyledLabel htmlFor="selectPortfolio">
            <StyledChooseButton>
              {selectedFile ? "Selected file" : "Choose file"}
            </StyledChooseButton>
          </StyledLabel>
          {selectedFile && (
            <StyledFileText>
              {selectedFile.name ?? selectedFile}
              <IconButton onClick={onDeleteIcon}>
                <Delete color="secondary" />
              </IconButton>
            </StyledFileText>
          )}
        </StyledChooseFileContainer>
        <StyledErrorText>{selectedFileError}</StyledErrorText>
        <StyledText>Work As</StyledText>
        <StyledSelectionButton
          onClick={() => setWorkAs("Full Time")}
          startIcon={
            <CheckBox color={workAs === "Full Time" ? "primary" : "disabled"} />
          }
        >
          <StyledChooseText>Full Time</StyledChooseText>
        </StyledSelectionButton>
        <StyledSelectionButton
          onClick={() => setWorkAs("Part Time")}
          startIcon={
            <CheckBox color={workAs === "Part Time" ? "primary" : "disabled"} />
          }
        >
          <StyledChooseText>Part Time</StyledChooseText>
        </StyledSelectionButton>
        <StyledErrorText>{error.workAsError}</StyledErrorText>
        <SnackBar
          open={openSnackBar}
          onClose={handleCloseSnackBar}
          onCloseClick={handleCloseSnackBar}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          message={snackBarMessage}
        />
        <StyledButtonContainer>
          <StyledButton
            loading={loading}
            onClick={validation}
            progressColor="info"
          >
            {vacancyId ? "Edit" : "Add"}
          </StyledButton>
        </StyledButtonContainer>
      </StyledContainer>
    </Slider>
  );
};

export default memo(EditVacancySlider);
